import { ReactNode } from 'react'

import FormCaption, { CaptionType } from '@/components/view/atoms/form/FormCaption'

interface Props {
  message?: string | ReactNode
}

const FormError = ({ message }: Props) => {
  return <>{message && <FormCaption type={CaptionType.CRITICAL}>{message}</FormCaption>}</>
}

export default FormError
